/**
 * @generated SignedSource<<7707ea43ddb066703b17d9354161e725>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedNewArrivalsCarouselTabs_personalizationCollections$data = ReadonlyArray<{
  readonly categoryItems: ReadonlyArray<{
    readonly serviceId: string | null;
  } | null> | null;
  readonly categoryTitle: string | null;
  readonly linkData: {
    readonly path: string | null;
  };
  readonly " $fragmentType": "HpSharedNewArrivalsCarouselTabs_personalizationCollections";
}>;
export type HpSharedNewArrivalsCarouselTabs_personalizationCollections$key = ReadonlyArray<{
  readonly " $data"?: HpSharedNewArrivalsCarouselTabs_personalizationCollections$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedNewArrivalsCarouselTabs_personalizationCollections">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "HpSharedNewArrivalsCarouselTabs_personalizationCollections",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "categoryItems",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PersonalizationCollectionType",
  "abstractKey": null
};

(node as any).hash = "3e4597b9525e1ec1ba87ccf6ba08dd92";

export default node;
